import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ProjectsPage from './features/projects/ProjectsPage';
import WorkflowPage from './features/workflow/WorkflowPage';
import LoginPage from './features/auth/LoginPage';
import RegisterPage from './features/auth/RegisterPage';
import AdminLayout from './features/admin/AdminLayout';
import AdminDashboard from './features/admin/AdminDashboard';
import TenantsPage from './features/admin/TenantsPage';
import ProtectedRoute from './components/ProtectedRoute';
import useAuthStore from './stores/authStore';

// Configurazione React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minuti
      retry: 1
    }
  }
});

function App() {
  const { fetchMe, isAuthenticated } = useAuthStore();

  // Inizializza autenticazione al mount
  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token && !isAuthenticated) {
      fetchMe().catch(err => {
        console.error('Failed to fetch user:', err);
      });
    }
  }, [fetchMe, isAuthenticated]);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-background">
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            
            {/* Protected Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Navigate to="/projects" replace />
              </ProtectedRoute>
            } />
            
            <Route path="/projects" element={
              <ProtectedRoute>
                <ProjectsPage />
              </ProtectedRoute>
            } />
            
            <Route path="/projects/:projectId/workflow" element={
              <ProtectedRoute>
                <WorkflowPage />
              </ProtectedRoute>
            } />
            
            <Route path="/projects/:projectId/workflow/step/:stepNumber" element={
              <ProtectedRoute>
                <WorkflowPage />
              </ProtectedRoute>
            } />

            {/* Admin Routes (Superadmin only) */}
            <Route path="/admin" element={
              <ProtectedRoute requiredRole="superadmin">
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<AdminDashboard />} />
              <Route path="tenants" element={<TenantsPage />} />
              {/* TODO: Add Plans, Prompts, Models pages */}
            </Route>
            
            {/* 404 */}
            <Route path="*" element={<Navigate to="/projects" replace />} />
          </Routes>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
